import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-error, [glxyError]',
  standalone: false,
})
export class ErrorDirective {
  @HostBinding('class') class = 'glxy-error';
}
